import { LoadState } from "../../constants/enums";

export interface IRequestedUserNameRecord {
  request_user_name_uuid: string;
  first_name: string | null;
  last_name: string | null;
  business: string | null;
  email: string | null;
  phone: string | null;
  policy: string | null;
  status: string;
  created_by_id: string | null;
  created_by_name: string | null;
  modified_by_id: string | null;
  modified_by_name: string | null;
}

export interface IRequestedUserNameState {
  list: IRequestedUserNameRecord[];
  loading: LoadState;
  totalRecords: number;
  statusUpdateLoading: LoadState;
  error: string | null;
}

export const initialRequestedUserNameState: IRequestedUserNameState = {
  list: [],
  loading: LoadState.NotLoaded,
  totalRecords: 0,
  statusUpdateLoading: LoadState.NotLoaded,
  error: null,
};
